import React from 'react';
import { Button, Modal, Row, Typography } from 'components';
import { useMainSupplierSetModal } from 'feature/brandTabs/pricingAndSuppliers/supplierGrid/mainSupplierSetModal/useMainSupplierSetModal';

const { Title, Text } = Typography;

interface IMainSupplierSetModal {
  modalState: boolean;
  onModalStateChange: () => void;
  supplierId: string | null;
}

export const MainSupplierSetModal = React.memo((props: IMainSupplierSetModal) => {
  const { modalState, onModalStateChange, supplierId } = props;
  const { handleCancel, handleSubmit, contextHolder, isLoading } = useMainSupplierSetModal({
    onModalStateChange,
    supplierId,
  });
  return (
    <>
      {contextHolder}
      <Modal
        open={modalState}
        onOk={handleSubmit}
        onCancel={handleCancel}
        closable={false}
        width={360}
        centered
        footer={() => (
          <Row wrap={false} className={'gap-8'} style={{ marginTop: '24px' }}>
            <Button block size={'large'} onClick={handleCancel}>
              Cancel
            </Button>
            <Button loading={isLoading} block size={'large'} type="primary" onClick={handleSubmit}>
              Set Main
            </Button>
          </Row>
        )}
      >
        <Row align={'middle'} gutter={[0, 12]} justify={'center'}>
          <Title style={{ color: '#222530', textAlign: 'center' }} level={3}>
            Set as Main Supplier
          </Title>
          <Text className={'center'}>Are you sure you want to set this supplier as the main one?</Text>
        </Row>
      </Modal>
    </>
  );
});
